/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/announcements",
    },
    (router) => {
      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api/annoncement@motd",
            path: "/motd",
          });
        },
      );
    },
  );
}
